export { default as Tooltip } from './src/Tooltip'
